import dayjs, { Dayjs } from "dayjs";
import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import { useOneToOneCredits } from "@/data/one-to-one.ts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomDatePicker from "@edusogno/composites/calendar";
import routes from "@/config/routes.ts";
import MobileLayout from "@/components/one-to-one/MobileLayout.tsx";
import { Trans, useTranslation } from "react-i18next";
import Button from "@edusogno/primitives/button";
import Warning from "@/components/ui/Warning.tsx";
import { AllTutorsHourObj } from "@/pages/OneToOne";

interface MobileViewProps {
  selectedDayEvents: AllTutorsHourObj[];
  selectedPreviousTutorDayEvents: string[];
  previousTutorInfo?: { name: string; image: string; token: string };
  availableCalendarDays: Dayjs[];
  isLoading: boolean;
}

const MobileView = ({
  selectedDayEvents,
  availableCalendarDays,
  selectedPreviousTutorDayEvents,
  previousTutorInfo,
  isLoading,
}: MobileViewProps) => {
  const { date, credits: stateCredits, setState } = useOneToOne();

  const { credits } = useOneToOneCredits();

  const { t, i18n } = useTranslation();

  const navigate = useNavigate();


  useEffect(() => {
    if (credits) {
      setState("credits", credits.item.count_credits);
      setState("isFirstSession", credits.item.is_first_one_to_one);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credits]);


  return (
    !isLoading && (
      <MobileLayout isLoading={isLoading}>
        <CustomDatePicker
          lang={i18n.language as "en" | "it" | "es" | "fr" | "de"}
          minDate={dayjs()}
          openDates={availableCalendarDays}
          type={"single"}
          value={
            typeof date === "string" ? date : dayjs(date).format("YYYY-MM-DD")
          }
          onValueChange={(d) => setState("date", d as string)}
          maxDate={dayjs().add(7, "days")}
          className={"w-full aspect-square !max-h-[500px]"}
        />
        <div className={"flex w-full flex-col gap-2"}>
          <Warning
            text={
              <Trans
                i18nKey="one_to_one.warning_timezome"
                components={{
                  b: <b className="font-semibold" />,
                }}
              ></Trans>
            }
          />
          <Button
            disabled={stateCredits === 0 || !date}
            onClick={() =>
              navigate(routes.one_to_one_select_hour, {
                state: {
                  selectedDayEvents,
                  selectedPreviousTutorDayEvents,
                  previousTutorInfo,
                },
              })
            }
            color={"primary"}
            size={"md"}
            className={"mx-auto"}
          >
            {t("btns.next")}
          </Button>
        </div>
      </MobileLayout>
    )
  );
};

export default MobileView;
